/**
 * The mid-run pause that bridges loop 1 into the infinite repeats.
 * Mode-agnostic — the celebration of "loop 1 cleared, infinite mode
 * unlocked" is the same UX in Pulse and Circles.
 *
 * Two stages:
 *   - splash:   3 stars + "Loop 1 cleared" celebration
 *   - mode_card: "INFINITE MODE / SPEED UP" banner before the
 *                canvas-drawn lead-in countdown takes over.
 */
export interface LoopFinaleOverlayProps {
  stage: 'splash' | 'mode_card';
}

export function LoopFinaleOverlay({ stage }: LoopFinaleOverlayProps) {
  return (
    <div
      className="play-overlay loop-finale-overlay"
      data-testid="loop-finale-overlay"
      data-stage={stage}
    >
      {stage === 'splash' ? (
        <div className="loop-finale-card loop-finale-splash">
          <div className="loop-finale-stars" aria-label="Three stars earned">
            <span>★</span>
            <span>★</span>
            <span>★</span>
          </div>
          <h2 className="loop-finale-title">Loop 1 cleared!</h2>
          <p className="loop-finale-sub">Three stars locked in.</p>
        </div>
      ) : (
        <div className="loop-finale-card loop-finale-mode">
          <p className="loop-finale-eyebrow">Entering</p>
          <h2 className="loop-finale-mode-title">INFINITE MODE</h2>
          <p className="loop-finale-warning">
            <span className="loop-finale-warning-pulse">SPEED UP</span>
          </p>
          <p className="loop-finale-hint">
            Music speeds up every loop — no finish line, just rack up score.
          </p>
        </div>
      )}
    </div>
  );
}
